// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2-yzc","approved":"Status_approved__A5udO","rejected":"Status_rejected__2bI70","expired":"Status_expired__oU_RD","label":"Status_label__29Omv"};